export function buildDigitRegex(regex: string, flags?: string): RegExp {
    const finalRegex = regex
        .replace(/#[^\n]+/g, '')
        .replace(/\s+/g, '');
    return new RegExp(finalRegex, flags);
}
